import {
  Image,
  ListItem,
  SimpleGrid,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import type { IconsList } from 'types/cms/blocks';

export function IconsListLarge({ icons }: Pick<IconsList, 'icons'>) {
  const iconsAmount = icons?.length;

  return (
    <SimpleGrid
      as={UnorderedList}
      columns={{
        base: 2,
        lg: iconsAmount,
      }}
      listStyleType="none"
      m={0}
      p={0}
      spacingY="sm"
    >
      {icons.map((icon) => (
        <ListItem key={icon._key} px="3xs" textAlign="center">
          <Image
            boxSize="48px"
            objectFit="contain"
            mx="auto"
            src={icon.asset.url}
            alt=""
          />
          <Text mt="3xs" size="overline">
            {icon.label}
          </Text>
        </ListItem>
      ))}
    </SimpleGrid>
  );
}
